const zh_CN = {
  title: '仪表盘迁移',
};
export default zh_CN;
